import { Toast } from 'primereact/toast';
import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import AppBreadcrumb from '../../components/CustomeBreadcrumb/AppBreadcrumb';
import { GET_ADMIT_DETAIL } from '../../config/ApiConstant';
import { getAllDetailsDirect } from '../../service/ProductService';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';

import { defaultRowOptions, defaultPageRowOptions, paginatorLinks, showingEntries, Skeletonitems, SkeletonbodyTemplate } from '../../appconfig/Settings';
import { admitColumns } from '../../appconfig/DatatableSetting';

export const AdmitDetails = () => {
    document.title = 'View Admit Detail | GSPC';

    const { id }: any = useParams();
    const toast = useRef<Toast>(null);

    const [pageLoad, setPageLoad] = useState<boolean>(false);
    const [admitDetails, setAdmitDetails] = useState<any>(null);

    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<string | null>(null);

    // useeffect
    useEffect(() => {
        if (id) {
            getAdmitDetailById(id);
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    // api call for get admitted details from id
    const getAdmitDetailById = async (admitID: any) => {
        try {
            setPageLoad(true);
            const params: any = { type: 'Admin' };
            if (admitID) params.id = atob(admitID);

            const url = `${GET_ADMIT_DETAIL}?${new URLSearchParams(params)}`;
            const response = await getAllDetailsDirect(url);

            if (response) setAdmitDetails(response);
        } catch (error: any) {
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        } finally {
            setPageLoad(false);
        }
    };

    // Template to open admitted list file
    const fileTemplate = () =>
        !window.cn(admitDetails?.admitted_data?.admitted_list) ? (
            <Button icon="pi pi-file" label="Download Admitted List" className="flex ml-auto p-button-sm p-button-primary" onClick={() => window.open(admitDetails.admitted_data.admitted_list, '_blank')} />
        ) : (
            'Not Available'
        );

    return (
        <>
            <Toast ref={toast} />
            <AppBreadcrumb currentMenu="Admitted List" pageName="Admitted List" pageTitle="Admitted List" goToPage />

            {!pageLoad && admitDetails && (
                <div className="grid crud-demo">
                    {/* ---- College / Degree Info ---- */}
                    <div className="col-12 mb-4">
                        <Card>
                            {/* Row 1: College + FileTemplate side by side */}
                            <div className="grid mb-3">
                                <div className="col-12 md:col-6">
                                    <p className="m-0">
                                        <strong>College:</strong> {!window.cn(admitDetails?.admitted_data?.college_name) ? admitDetails?.admitted_data?.college_name : '-'}
                                    </p>
                                </div>
                                <div className="col-12 md:col-6">{fileTemplate()}</div>
                            </div>

                            {/* Row 2: Remaining details */}
                            <div className="grid">
                                <div className="col-12 md:col-4">
                                    <p className="m-0">
                                        <strong>Degree:</strong> {!window.cn(admitDetails?.admitted_data?.degree_name) ? admitDetails?.admitted_data?.degree_name : '-'}
                                    </p>
                                </div>
                                <div className="col-12 md:col-4">
                                    <p className="m-0">
                                        <strong>From Year:</strong> {!window.cn(admitDetails?.admitted_data?.from_year) ? admitDetails?.admitted_data?.from_year : '-'}
                                    </p>
                                </div>
                                <div className="col-12 md:col-4">
                                    <p className="m-0">
                                        <strong>To Year:</strong> {!window.cn(admitDetails?.admitted_data?.to_year) ? admitDetails?.admitted_data?.to_year : '-'}
                                    </p>
                                </div>
                            </div>
                        </Card>
                    </div>

                    {/* ---- Students List ---- */}
                    <div className="col-12">
                        <Card title="Admitted Students">
                            {!pageLoad ? (
                                <DataTable
                                    value={admitDetails?.data}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={admitDetails?.data.length >= 10}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    className="datatable-responsive p-datatable-sm"
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                    emptyMessage="No admitted students found"
                                    removableSort
                                >
                                    {admitColumns.map((col) => {
                                        if (col.field === 'sr_no') {
                                            return <Column key={col.field} header={col.header} body={(_: any, { rowIndex }) => rowIndex + 1} />;
                                        } else if (['first_name', 'middle_name', 'last_name', 'enrollment_no'].includes(col.field)) {
                                            return <Column key={col.field} field={col.field} header={col.header} filter filterPlaceholder={`Search by ${col.header}`} sortable />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable />;
                                        }
                                    })}
                                </DataTable>
                            ) : (
                                <DataTable value={Skeletonitems}>
                                    {admitColumns.map((col) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            )}
                        </Card>
                    </div>
                </div>
            )}
        </>
    );
};
